import axios from 'axios'

export const registerResponseInterceptor = async (response) => {
  response.use(
    (response) => {
      if (response && response.data) {
        return response.data
      }
      return response
    },
    (err) => {
      if (err.response.status === 401) {
        delete axios.defaults.headers.common.Authorization
      }
      return Promise.reject(err)
    }
  )
}
